<template>
  <component :is="tag_name" :class="type" :title="hints ? hints[type] : ''">
    <template v-for="(part, index) in parts">
      <span v-if="part.type === 'text'" v-html="part.text" :key="index"></span>
      <a v-else-if="part.type === 'link'" :href="part.link" :key="index" target="_blank">{{ part.text }}</a>
      <input v-else-if="part.type === 'input'" :key="index" v-model="variables[part.name]" type="text">
    </template>
  </component>
</template>

<script>
export default {
  name: 'RichText',
  props: ['parts', 'type', 'variables', 'hints', 'tag'],
  computed: {
    'tag_name': function () {
      if (this.tag) {
        return this.tag
      } else {
        return 'div'
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RichText.vue